import { graphql } from "@/gql";

export const INCIDENT_TYPES_QUERY = graphql(`
  query INCIDENT_TYPES_QUERY {
    incidentTypes {
      edges {
        node {
          id
          name
          description
          category
          useAllowlist
        }
      }
    }
  }
`);
